import { motion } from 'framer-motion';
import { FaCode, FaLightbulb, FaRocket } from 'react-icons/fa';
import { personalInfo } from '../../../config';

const AboutTab = () => {
  const highlights = [
    {
      icon: <FaCode className="text-3xl text-gray-900 dark:text-white" />,
      title: personalInfo.highlights[0].title,
      description: personalInfo.highlights[0].description
    },
    {
      icon: <FaLightbulb className="text-3xl text-gray-900 dark:text-white" />,
      title: personalInfo.highlights[1].title,
      description: personalInfo.highlights[1].description
    },
    {
      icon: <FaRocket className="text-3xl text-gray-900 dark:text-white" />,
      title: personalInfo.highlights[2].title,
      description: personalInfo.highlights[2].description
    }
  ];

  return (
    <div className="lg:pt-12 pt-8 w-full md:w-12/12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-4xl font-bold mb-6 text-gray-900 dark:text-white">About Me</h2>
        
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {highlights.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass-effect p-6 rounded-xl card-hover"
            >
              <div className="mb-4">{item.icon}</div>
              <h3 className="text-lg font-semibold mb-2 dark:text-white">{item.title}</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">{item.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="space-y-6">
          <motion.p 
            className="text-lg leading-relaxed text-gray-700 dark:text-gray-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            {personalInfo.about.intro}
          </motion.p>
          
          <motion.p 
            className="text-lg leading-relaxed text-gray-700 dark:text-gray-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            {personalInfo.about.journey}
          </motion.p>
          
          <motion.p 
            className="text-lg leading-relaxed text-gray-700 dark:text-gray-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            {personalInfo.about.passion}
          </motion.p>

          <motion.p 
            className="text-lg leading-relaxed text-gray-700 dark:text-gray-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            {personalInfo.about.tech}
          </motion.p>

          <motion.p 
            className="text-lg leading-relaxed text-gray-700 dark:text-gray-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.7 }}
          >
            {personalInfo.about.philosophy}
          </motion.p>
        </div>
      </motion.div>
    </div>
  );
};

export default AboutTab;

